import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { Button } from "@/components/ui/button";
import { useToast } from "@/hooks/use-toast";
import { DeleteUserDialog } from "./DeleteUserDialog";

interface DeleteUserButtonProps {
  userId: string;
  onDeleted?: () => void;
}

export const DeleteUserButton = ({ userId, onDeleted }: DeleteUserButtonProps) => {
  const [isDeleting, setIsDeleting] = useState(false);
  const [showDialog, setShowDialog] = useState(false);
  const navigate = useNavigate();
  const { toast } = useToast();

  const handleDelete = async () => {
    try {
      setIsDeleting(true);
      console.log("Calling delete-user function for:", userId);
      
      const { error } = await supabase.functions.invoke('delete-user', {
        body: { userId }
      });

      if (error) throw error;

      toast({
        title: "Success",
        description: "User deleted successfully",
      });

      if (onDeleted) {
        onDeleted();
      } else {
        navigate("/admin/clients");
      }
    } catch (error: any) {
      console.error('Error deleting user:', error);
      toast({
        variant: "destructive",
        title: "Error",
        description: "Failed to delete user. Please try again.",
      });
    } finally {
      setIsDeleting(false);
      setShowDialog(false);
    }
  };

  return (
    <>
      <Button 
        variant="destructive" 
        disabled={isDeleting}
        onClick={() => setShowDialog(true)}
      >
        {isDeleting ? "Deleting..." : "Delete User"}
      </Button>
      <DeleteUserDialog 
        open={showDialog}
        onOpenChange={setShowDialog}
        onConfirm={handleDelete}
      />
    </>
  );
};